/**
* @ngdoc service
* @name common.constant:ModalConstant
* @description
* Support the logic for the debug component.
*/
(function() {
    'use strict';
    
    angular
    .module('itxApp.common')
    .constant('MODALS', [
        {
            alias: 'Mi cuenta update email',
            template: 'dialog-success.template.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
                title: inditex.text('myaccount_access_update_email'),
                message: inditex.text('myaccount_access_update_email_txt')
            }
        },



        {
            alias: 'devolucion',
            template: '<itx-my-account-order-return order=order></itx-my-account-order-return>',
            className: 'new-modal ma-modal-md ngdialog-theme-plain ngdialog-order-return',
            plain: true,
            showClose: true,
            data: {
                order: {
                    date: "2019-07-08",
                    daysLeftToCleanCart: 13,
                    deliveryDate: null,
                    eInvoiceStatus: "pending",
                    giftPacking: false,
                    giftTicket: "0",
                    guestToken: null,
                    hasSubOrders: true,
                    id: 113497517
                }
            }
        },



        // {
        //     alias: 'devolucion',
        //         templateUrl: 'OrderReturnConfirmationDialog.component.html',
        //         className: 'new-modal ma-modal-md ngdialog-theme-plain ngdialog-order-return',
        //         plain: true,
        //         showClose: true,
        //         data: {
        //             order: _this.order
        //         }
        //     },
            // {
            //     alias: 'devolucion-2',
            //     className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-order-return',
            //     plain: true,
            //     showClose: true,
            // },
            // {
            //     alias: 'devolucion-3',
            //     template: '<itx-my-account-order-return order="ngDialogData.order" is-gift-ticket="true"></itx-my-account-order-return>',
            //     className: 'ngdialog-theme-plain ngdialog-order-return',
            //     plain: true,
            //     showClose: true,
            //     data: {
            //         order: response[0].order
            //     }
            // },
        {
            alias: 'Mi cuenta acceso actualizado',
            template: 'dialog-success.template.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
                title: inditex.text('myaccount_access_update'),
                message: inditex.text('myaccount_access_update_txt')
            }
        },
        {
            alias: 'Dialog success template',
            template: 'dialog-success.template.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
                title: inditex.text('myaccount_access_update'),
                message: inditex.text('myaccount_access_update_txt')
            }
        },
        {
            alias: 'Success dialog',
            template: 'dialog-success.template.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
                title: inditex.text('myaccount_phone_update'),
                message: inditex.text('myaccount_phone_update_txt')
            }
        },
        {
            alias: 'Card delete confirmation',
            templateUrl: 'MyAccountCardDeleteConfirmation.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
                card: {
                    paymentCode: "1", 
                    affinityEmployee: false,
                    alias: "",
                    defaultCard: true,
                    expired: "0",
                    expiredDate: "**/**",
                    hash: "9f2a9a30684e4cae87e4663e0b97b170",
                    holderName: "dsa",
                    paymentCodeName: "VISA",
                    paymentMethod: "VISA",
                    paymentModes: [],
                    printablePan: "************1111",
                    requestPaymentDetails: "0",
                    trustedAddresses: (4) ["4711686018490257422", "4711686018490257425", "4711686018490257432", "4711686018490261436"],
                    trustedPhysicalStores: [446]
                },
                text: {
                    button: "Eliminar",
                    deleted: "ELIMINACIÓN TARJETA",
                    title: "Eliminar Tarjeta"
                }
            }
        },
        {
            alias: 'Plaining dialog cancel',
            template: '<itx-my-account-card-delete card="ngDialogData.card" on-continue="ngDialogData.onDeleted()"></itx-my-account-card-delete>',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel',
            plain: true,
            showClose: true,
            data: {
                card: {
                    paymentCode: "1", 
                    affinityEmployee: false,
                    alias: "",
                    defaultCard: true,
                    expired: "0",
                    expiredDate: "**/**",
                    hash: "9f2a9a30684e4cae87e4663e0b97b170",
                    holderName: "dsa",
                    paymentCodeName: "VISA",
                    paymentMethod: "VISA",
                    paymentModes: [],
                    printablePan: "************1111",
                    requestPaymentDetails: "0",
                    trustedAddresses: (4) ["4711686018490257422", "4711686018490257425", "4711686018490257432", "4711686018490261436"],
                    trustedPhysicalStores: [446]
                }
            }
        },
        {
            alias: 'Plaining dialog order cancel  ***',
            template: '<itx-my-account-card-delete-walletcard"></itx-my-account-card-delete-wallet>',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel',
            plain: true,
            showClose: true,
            data: {
                card: {
                    paymentCode: "1", 
                    affinityEmployee: false,
                    alias: "",
                    defaultCard: true,
                    expired: "0",
                    expiredDate: "**/**",
                    hash: "9f2a9a30684e4cae87e4663e0b97b170",
                    holderName: "dsa",
                    paymentCodeName: "VISA",
                    paymentMethod: "VISA",
                    paymentModes: [],
                    printablePan: "************1111",
                    requestPaymentDetails: "0",
                    trustedAddresses: (4) ["4711686018490257422", "4711686018490257425", "4711686018490257432", "4711686018490261436"],
                    trustedPhysicalStores: [446]
                }
            }
        },
        {
            alias: 'Account info update',
            template: 'my-account-info-update-confirmation.html',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
            showClose: true
        },
        {
            alias: 'Unsuscribe newsletter ***',
            template: ['<divclass="content-dialog">', '<divclass="ma-modal-header">', '</div>', '<divclass="ma-modal-body">', '<h2class="alpham-b-20"', 'ng-bind-html="::ngDialogData.text.cancellationConfirm">', '</h2>', '<buttontype="button"', 'class="btnbtn-defaultbtn--smallbtn-block"',
                'ng-click="ngDialogData.confirm()"', 'ng-bind-html="::ngDialogData.text.accept">', '</button>', '</div>', '</div>'
            ].join(''),
            className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel',
            plain: true,
            showClose: true,
            data: {
                text: {
                    accept: "DARSE DE BAJA",
                    acceptCsbs: "SUSCRIBIR",
                    cancellationConfirm: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    cancellationRequest: "SOLICITUD DE BAJA",
                    cancellationTitle: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    subcribeConfirm: "Para activar esta funcionalidad, deberá confirmar la suscripción al servicio a través del e-mail que le enviaremos.",
                    subribeTitle: "Notificación Coming Soon/Back Soon",
                    unSubcribeConfirm: "Al guardar, le daremos de baja en el servicio de notificaciones Coming Soon/Back Soon.",
                    unSubribeTitle: "Notificación Coming Soon/Back Soon"
                },
                //confirm: _this.unsubscribe
            }
        },
        {
            alias: 'Order cancel **',
            template: ['<divclass="content-dialog">', '<divclass="ma-modal-header">', '<h2class="text"', 'ng-bind-html="::ngDialogData.text.unSubribeTitle"></h2>', '</div>', '<divclass="ma-modal-body">', '<pclass="text"', 'ng-bind-html="::ngDialogData.text.unSubribeTitle">', '</p>', '<buttontype="button"',
                'class="btn btn-primary btn--small btn-block"', 'ng-click="ngDialogData.confirm()"', 'ng-bind-html="::ngDialogData.text.accept">', '</button>', '</div>', '</div>'
            ].join(''),
            className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel',
            plain: true,
            showClose: true,
            data: {
                text: {
                    accept: "DARSE DE BAJA",
                    acceptCsbs: "SUSCRIBIR",
                    cancellationConfirm: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    cancellationRequest: "SOLICITUD DE BAJA",
                    cancellationTitle: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    subcribeConfirm: "Para activar esta funcionalidad, deberá confirmar la suscripción al servicio a través del e-mail que le enviaremos.",
                    subribeTitle: "Notificación Coming Soon/Back Soon",
                    unSubcribeConfirm: "Al guardar, le daremos de baja en el servicio de notificaciones Coming Soon/Back Soon.",
                    unSubribeTitle: "Notificación Coming Soon/Back Soon"
                },
            }
        },
        {
            alias: 'Accept cbs',
            template: ['<divclass="dialog-content">', '<divclass="ma-modal-header">', '<h2class="text"', 'ng-bind-html="::ngDialogData.text.subribeTitle"></h2>', '</div>', '<divclass="ma-modal-body">', '<pclass="text"', 'ng-bind-html="::ngDialogData.text.subcribeConfirm">', '</p>', '<buttontype="button"',
                'class="btn btn-primary btn--small btn-block"', 'ng-click="ngDialogData.confirm()"', 'ng-bind-html="::ngDialogData.text.acceptCsbs">', '</button>', '</div>', '</div>'
            ].join(''),
            className: 'ngdialog-theme-plain',
            plain: true,
            showClose: true,
            data: {
                text: {
                    accept: "DARSE DE BAJA",
                    acceptCsbs: "SUSCRIBIR",
                    cancellationConfirm: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    cancellationRequest: "SOLICITUD DE BAJA",
                    cancellationTitle: "¿QUIERES DEJAR DE RECIBIR NUESTRA NEWSLETTER? ",
                    subcribeConfirm: "Para activar esta funcionalidad, deberá confirmar la suscripción al servicio a través del e-mail que le enviaremos.",
                    subribeTitle: "Notificación Coming Soon/Back Soon",
                    unSubcribeConfirm: "Al guardar, le daremos de baja en el servicio de notificaciones Coming Soon/Back Soon.",
                    unSubribeTitle: "Notificación Coming Soon/Back Soon"
                }
            }
        },
        {
            alias: 'Account order Cancel',
            template: '<itx-my-account-order-cancel>' + '</itx-my-account-order-cancel>',
            className: 'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel',
            plain: true,
            showClose: true,
            data: {
                order: {
                        adjustment: [],
                        assistedPurchase: 0,
                        billingAddressId: "4711686018490307444",
                        courier: null,
                        date: "2019-07-08",
                        daysLeftToCleanCart: 13,
                        deliveryDate: null,
                        eInvoiceStatus: "pending",
                        giftPacking: false,
                        giftTicket: "0",
                        guestToken: null,
                        hasSubOrders: true,
                        id: 113497517,
                        isEnabledReturnableDateLimit: 1,
                        isHazardousGood: "false",
                        isMailRegistered: null,
                        isPaperless: true,
                        isReplacement: false,
                        isReturnableDate: 1,
                        isTailoring: false,
                        items: [{id: 321290024, isAutoAdd: false, isItemHazardousGood: "false", parentId: 8300002, quantity: 1}],
                        lastUpdate: "2019-07-08T10:43:04.040Z",
                        memberId: 516198311,
                        message: null,
                        orderTracking: {11961594: {fechaEstimada: "2019-07-11 23:59:59.59", fechaEstimadaUTC: "2019-07-11T21:59:59.000Z"}},
                        payment: [{id: 8806953862, code: 1, ppcId: null, name: "VISA", type: "VISA", cardHolder: null}],
                        phonePurchase: false,
                        phonePurchaseAgentName: "",
                        promotion: [],
                        repay: false,
                        repayable: false,
                        requestedDate: null,
                        sfiCreditEnabled: false,
                        shipping: {shippingMethodId: 19268, name: "Recoger en tienda", kind: "pickup", identifier: 4},
                        shippingMethods: [],
                        shippingPrice: 0,
                        shippingPriceEuro: 0,
                        shippingTax: 0,
                        shippingTaxArray: [],
                        status: "A",
                        statusText: "En trámite",
                        statusTracking: "",
                        suborders: [{id: 11961594, status: "A", items: [{id: 321290024}, {id: 321295004}]}],
                        subordersNumber: 1,
                        tax: 0,
                        totalAdjustment: 0,
                        totalOrder: 10990,
                        totalOrderEuro: 0,
                        totalProduct: 10990,
                        trackingNumber: null,
                        urlTracking: null,
                        urlTrackingCIS: null
                    }
            }
        },
        {
            alias: 'My account order return',
            template: '<itx-my-account-order-return order=order></itx-my-account-order-return>',
            className: 'new-modal ma-modal-md ngdialog-theme-plain ngdialog-order-return',
            plain: true,
            showClose: true,
            data: {
                order: {
                    date: "2019-07-08",
                    daysLeftToCleanCart: 13,
                    deliveryDate: null,
                    eInvoiceStatus: "pending",
                    giftPacking: false,
                    giftTicket: "0",
                    guestToken: null,
                    hasSubOrders: true,
                    id: 113497517
                }
            }
        },
        {
            alias: 'Cancel Order confirmation',
            template: 'MyAccountOrderCancelConfirmation.html',
            className: 'new-modalma-modal-smma-modal-macrongdialog-theme-plainngdialog-order-cancelngdialog-order-cancel-confirmation',
            showClose: true,
            data: {
            }
        },
        {
            alias: 'Store locator',
            template: '<itx-store-locator-header"></itx-store-locator-header"><itx-store-locator is-popup="true" close-dialog="closeThisDialog()" call-button="true"></itx-store-locator>',
            plain: true,
            className: 'ngdialog-theme-plain ngdialog-store-map',
            showClose: false,
            bindToController: true
        },
        {
            alias: 'Stock notification',
            template: '<itx-product-stock-availability data="ngDialogData"></itx-product-stock-availability>',
            className: 'stock-notification ngdialog-theme-plain',
            plain: true,
            showClose: true,
            data: {
                product: {
                    attachments: [],
                    availabilityDate: "2018-08-20 13:53:18.732",
                    backSoon: null,
                    bundleColors: [],
                    bundleProductSummaries: [],
                    detail: {description: ""},
                    family: "35",
                    familyCode: null,
                    familyName: "FALDAS",
                    familyNameEN: "SKIRTS",
                    field5: "706#1530799597155",
                    gridElemType: "PRODUCT",
                    id: 8325633,
                    image: null,
                    isBuyable: true,
                    isSales: null,
                    isTop: 0,
                    keywords: "",
                    mainColorid: "706",
                    name: "PANTALÓN CHINO FRANELA CARGO LIMITED EDITION",
                    nameEn: "LIMITED EDITION FLANNEL CARGO PANT CHINOS",
                    onSpecial: false,
                    productType: "Clothing",
                    productUrl: "pantalon-chino-franela-cargo-limited-edition-l00023021",
                    relatedCategories: [{id: 1859041, identifier: "ALL_MEN_COLECCION_BUSCADOR_BI2018", name: " ", urlCategory: true}],
                    section: "2",
                    sectionName: "HOMBRE",
                    sectionNameEN: "MEN",
                    sizeSystem: "501",
                    startDate: "2018-08-16 11:04:17.0",
                    subFamily: "971",
                    subFamilyCode: null,
                    tags: [],
                    type: "ProductBean",
                    unitsLot: 1
                },
                selectedSize: 44
            }
        },
        {
            alias: 'Filters dialog',
            template: 'filters-dialog-wrapper.tpl',
            className: 'ngdialog-theme-plain',
            showClose: false,
            appendClassName: 'filters-dialog-layout',
        },
        {
            alias: 'Product stock modal **',
            template: '<itx-product-stock color="ngDialogData.color "detail="ngDialogData.detail" reference="ngDialogData.reference" close-dialog="closeThisDialog()"></itx-product-stock>',
            plain: true,
            className: 'new-modal ma-modal-lg store-check-dialog ngdialog-theme-plain',
            showClose: true,
            data: {
                color: {
                    colFilter: [],
                    id: "403",
                    isContinuity: false,
                    modelHeigh: null,
                    modelName: null,
                    modelSize: null,
                    name: "AZUL CELESTE"
                },
                reference: "00032066-I2018"
            }
        },
        {
            alias: 'Contacta ',
            template: '<itx-contact close="closeThisDialog()"></itx-contact>',
            plain: true,
            className: 'product-info ngdialog-theme-plain new-modal ma-modal-lg',
            showClose: true
        },
        {
            alias: 'Store map',
            template: '<itx-store-locator-header close-dialog="closeThisDialog()"></itx-store-locator-header><itx-store-locator search-type="ngDialogData.searchType"' + 'is-popup="true"' + 'selected-sizes="ngDialogData.selectedSizes"' 
             + 'action="ngDialogData.action"' + 'close-dialog="closeThisDialog()">' + '</itx-store-locator>',
            plain: true,
            className: 'ngdialog-theme-plain ngdialog-store-map',
            bindToController: true,
            data: {
                searchType: 'store',
                action: false
            }
        },
        {
            alias: 'Payment dialog **',
            template: '<itx-payment-cod close-dialog="closeThisDialog"></itx-payment-cod>',
            plain: true,
            className: 'ngdialog-theme-plain payment-dialog',
            showClose: false
        },{
            alias: 'Theme plain',
            template: '<itx-payment-ideal-warn close-dialog="closeThisDialog()"></itx-payment-ideal-warn>',
            plain: true,
            className: 'ngdialog-theme-plain',
            showClose: false
        }, {
            alias: 'Payment dialog',
            template: '<itx-payment-p24 close-dialog="closeThisDialog"></itx-payment-p24>',
            plain: true,
            className: 'ngdialog-theme-plain payment-dialog',
            showClose: false
        }, {
            alias: 'Payment dialog paypal',
            template: '<itx-payment-paypal close-dialog="closeThisDialog"></itx-payment-paypal>',
            plain: true,
            className: 'new-modal ma-modal-sm ngdialog-theme-plain payment-dialog',
            showClose: true
        },
        {
            alias: 'Special shipping',
            template: ['<div>', '<div class="ma-modal-header">', '<h2> {{ngDialogData.title}} </h2>', '</div>', '<div class="ma-modal-body">', '<p>{{ngDialogData.description}}</p>', '</div>', '</div>'].join(''),
                className: 'new-modal ma-modal-sm ma-modal-special-shipping ngdialog-theme-plain',
                showClose: true,
                plain: true,
            data: {
                title: inditex.text('specialShipping.title'),
                description: inditex.text('specialShipping.description')
            }
        }, {
            alias: 'Shipping address',
            template: 'shipping-address-modal.component.html',
            className: 'ngdialog-theme-plain ma-modal-address new-modal ma-modal-md',
            plain: false,
            showClose: true,
            closeByDocument: false,
            data: {
                text: "Test text",
                filteredAddressBook: "Address book",
                editedAddress: {
                    addressLines: ["Rúa Juan Flórez 12", "1"],
                    addressName: "test@gmail.com|DuttiES",
                    addressType: "SB",
                    birthdate: "1993-05-10",
                    checkUserExists: null,
                    checkedAddress: null,
                    city: "A Coruña",
                    clientType: null,
                    colony: "-",
                    company: null,
                    countryCode: "ES",
                    countryName: "España",
                    district: null,
                    districtCode: null,
                    dropPointName: "",
                    dropType: "",
                    email: "test@gmail.com",
                    email2: null,
                    firstName: "Serg",
                    gender: "F",
                    id: "4711686018490363495",
                    idDropPointInterno: null,
                    invoice: "1",
                    isBilling: null,
                    isCompany: false,
                    isCompanyForDrop: null,
                    isFullAddress: null,
                    lastName: "Frag",
                    latitude: "",
                    longitude: "",
                    middleName: null,
                    municipality: "-",
                    phones: [{countryCode: "+34", subscriberNumber: "659329295", prefixCode: "+34"}],
                    preferred: false,
                    preferredLanguage: null,
                    primaryAddress: true,
                    primaryAddressEmail: null,
                    province: null,
                    replaceBilling: false,
                    selfAddress: null,
                    state: null,
                    stateCode: "ESC",
                    stateName: "A CORUÑA",
                    vatin: "47690793V",
                    zipCode: "15004"
                }
            }
        }, {
            alias: 'Pick up store',
            template: 'shipping-pickup-store-locator.component.html',
            className: 'ngdialog-theme-plain ngdialog-store-map ngdialog-checkout-map',
            showClose: false,
            bindToController: true,
            data: {
                storeId: 1234,
                searchType: 'store',
                zipCode: "08041"
            }
        },
        {
            alias: 'Social login',
            template: '<itx-social-login-link-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-link-account-dialog>',
            plain: true,
            className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
            showClose: true,
            data: {
                user: {
                    name: "Sfrag",
                    id: 123
                },
            }
        },
        {
            alias: 'Recover password',
            template: 'user-access-dialog-wrapper.tpl',
            className: 'new-modal ma-modal-md ma-modal-macro recover-dialog ngdialog-theme-plain',
            showClose: true,
            bindToController: true,
            data: 'recover-password',
            preCloseCallback: function() {
                imDispatcherService.sortEvent('pageview', null, null, 'login');
            }
        },{
            alias: 'Error modal',
            template: '<itx-error close-dialog="closeThisDialog()" message="ngDialogData.message" title="ngDialogData.title"></itx-error>',
            plain: true,
            className: '  new-modal ma-modal-xs error-dialog ngdialog-theme-plain ',
            showClose: true,
            data: {
                message: "Se ha producido un error a la hora de conectarse a la base de datos",
                title: "Se ha producido un error"
            }
        },


        {
            alias: 'modal rara',
    
            template: ['<div class="dialog-content">', 
            '  <h2 class="text"  title="ngDialogData.title"  > </h2>  ', 
   
            '  <p  class="text"', 
            '      message="ngDialogData.message">', 
            '  </p>', 
            '</div>' ],
            className: 'ngdialog-theme-plain',
            showClose: true,
            data: {
                message: "Se ha producido un error a la hora de conectarse a la base de datos",
                title: "Se ha producido un error"

            }
        }

    ]);
})();